import documentsicon from "../../../../../assets/images/description.svg";
import deviceIcon from "../../../../../assets/images/devices/phone_android.svg";
import useLanguageTranslate from "../../../../../hooks/useLanguageTranslate";
import BottomStickyBtnLayout from "../../../layouts/BottomStickyBtnLayout";
import SmartDeviceJourneyLayout from "../../../layouts/SmartDeviceJourneyLayout";
import SmartDeviceInfoCard from "./smartDeviceInfoCard";

const SmartDeviceDocumentsReadyInfo = ({
  continueClickHandler,
  hide_back_btn,
  show_close_btn,
  onClose,
  customBackHandler,
  isFirstPage = false,
}) => {
  const translate = useLanguageTranslate();

  return (
    <div className="w-full">
      <SmartDeviceJourneyLayout
        show_close_btn={show_close_btn}
        is_hide_back_btn={hide_back_btn}
        onClose={onClose}
        customBackHandler={customBackHandler}
        isFirstPage={isFirstPage}
      >
        <BottomStickyBtnLayout
          btn_onClick={continueClickHandler}
          btn_label={translate("Continue", "التالي")}
        >
          <div className="w-[33%] max767:w-full mx-auto ipad:w-[65%] pb-5 max767:px-4">
            <h1 className="text-[#1A2024] text-center text-2xl not-italic font-semibold leading-8 tracking-[-0.24px] max767:text-left  max767:rtl:text-right">
              {translate(
                "Ready to Start Your New Policy?",
                "هل أنت مستعد لبدء وثيقتك الجديدة؟"
              )}
            </h1>
            <p className="text-[#1A2024] text-center text-base not-italic font-normal leading-6 tracking-[-0.16px] mb-6 max767:text-left  max767:rtl:text-right">
              {translate(
                "Please ensure you have the following information and documents ready for smooth process.",
                "يرجى التأكد من توفر المعلومات والمستندات التالية لضمان عملية سلسة."
              )}
            </p>
            <div className="infoCards mb-6">
              <SmartDeviceInfoCard
                title={translate("Required Documents", "المستندات")}
                title_icon={documentsicon}
                infoData={[
                  {
                    en_label: "CPR Bahraini National ID",
                    ar_label: "رقم بطاقة الهوية (CPR)",
                    hasInfo: false,
                  },
                ]}
              />
              <SmartDeviceInfoCard
                title={translate("About your device", "حول جهازك")}
                title_icon={deviceIcon}
                infoData={[
                  {
                    en_label: "Purchase Receipt",
                    ar_label: "وثيقة شراء الجهاز",
                    hasInfo: false,
                  },
                  {
                    en_label: "Screenshot of IMEI Number (if applicable)",
                    ar_label:
                      "لقطة من شاشة هاتفك (screenshot) يظهر فيها رقم التعريف العالمي لأجهزة الهاتف المحمول (IMEI) إن وجد",
                    hasInfo: false,
                  },
                ]}
              />
            </div>
          </div>
        </BottomStickyBtnLayout>
      </SmartDeviceJourneyLayout>
    </div>
  );
};

export default SmartDeviceDocumentsReadyInfo;
